import Vue from "vue";
import Vuetify from "vuetify/lib";
Vue.use(Vuetify);
// .dark-primary-color    { background: #388E3C; }
// .default-primary-color { background: #4CAF50; }
// .light-primary-color   { background: #C8E6C9; }
// .text-primary-color    { color: #FFFFFF; }
// .accent-color          { background: #8BC34A; }
// .primary-text-color    { color: #212121; }
// .secondary-text-color  { color: #757575; }
// .divider-color         { border-color: #BDBDBD; }
export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#b6d02e",
        secondary: "#757575",
        accent: "#03A9F4",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
        lightPrimary: "#BBDEFB",
      },
      dark: {
        background: '#072406',
      }
    },
  },
  icons: {
    iconfont: "md",
  },
});
